import { render, staticRenderFns } from "./common_empty.vue?vue&type=template&id=f234cd1c&scoped=true&"
import script from "./common_empty.vue?vue&type=script&lang=ts&"
export * from "./common_empty.vue?vue&type=script&lang=ts&"
import style0 from "./common_empty.vue?vue&type=style&index=0&id=f234cd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f234cd1c",
  null
  
)

export default component.exports